import FetchHelper from '../helpers/fetch_helper';

const PasswordResetDispatcher = {
  async fetchPasswordResetNotificationTypes({ username }) {
    return (
      await FetchHelper.fetchJson(`users/password-reset/types`, {
        method: 'POST',
        body: { username },
      })
    )?.results;
  },

  async generatePasswordResetOTP({ username, type }) {
    const results = (
      await FetchHelper.fetchJson(`users/password-reset/generate`, {
        method: 'POST',
        body: { username, type },
      })
    )?.results;

    this.setStoreVal('otpTokenResponse', results?.[0]);
    return results;
  },

  async validatePasswordResetOTP({ username, token }) {
    return (
      await FetchHelper.fetchJson(`users/password-reset/validate`, {
        method: 'POST',
        body: { username, token },
      })
    )?.results;
  },

  async fetchPasswordResetStatus({ username, token }) {
    return (
      await FetchHelper.fetchJson(`users/password-reset/status`, {
        method: 'POST',
        body: { username, token },
      })
    )?.results?.[0];
  },

  async resetPassword({ username, password, passwordValidation, isSetupFlow }) {
    return (
      await FetchHelper.fetchJson(`users/password-reset/reset`, {
        method: 'POST',
        body: { username, newPassword: password, confirmedPassword: passwordValidation, isSetupFlow },
      })
    )?.results;
  },
};

export default PasswordResetDispatcher;
